import React from 'react';
import PropTypes from 'prop-types';
import { LinkCopierContainer } from './LinkCopierContainer';
import HeaderBackground from './HeaderBackground';

const HeaderScrolling = ({
  HeaderMenuButton,
  HeaderLogo,
  articleHed,
}) => (
  <div className="header-scrolling">
    <HeaderBackground />
    <div className="header-contents">
      <div className="header-content">
        {HeaderMenuButton}
        {HeaderLogo}
        <div className="header-scrolling-article-hed">{articleHed}</div>
      </div>
      <div className="header-content">
        <LinkCopierContainer module="header_scrolling" />
      </div>
    </div>
  </div>
);

HeaderScrolling.propTypes = {
  HeaderMenuButton: PropTypes.node,
  HeaderLogo: PropTypes.node,
  articleHed: PropTypes.string,
};

export default HeaderScrolling;
